<template>
    <validation-observer ref="validationObserver" v-slot="{ invalid, errors }">
        <v-container fluid class="pa-0">
            <v-row no-gutters v-if="!disableEdit">

                <!-- NUMERIC RANGE START -->
                <v-col cols="6" class="pr-2">

                    <validation-provider
                            name="value"
                            vid="start"
                            mode="lazy"
                            rules="required|numeric"
                            v-slot="{ errors }">

                        <v-text-field
                                label="Value"
                                solo
                                :background-color="color"
                                hint="Value"
                                :hide-details="true"
                                placeholder="Enter value"
                                v-model="model"
                                :error-messages="errors"
                                @change="emit()"
                                autocomplete="off"
                        ></v-text-field>

                    </validation-provider>
                </v-col>

            </v-row>

            <!-- NON EDITABLE PRESENTATION -->
            <v-row no-gutters v-if="disableEdit">

                <v-col cols="12" class="ml-2">
                    <v-chip class="mr-2"
                            text-color="white"
                            dark small
                            label
                            color="grey darken-1">
                        {{ model }}
                    </v-chip>
                </v-col>

            </v-row>
        </v-container>

    </validation-observer>

</template>

<script>

    export default {

        props: {
            value: {
                required: false,
                type: Number | String,
                default: null,
            },
            disableEdit: {
                required: false,
                type: Boolean,
                default: false,
            },
            color: {
                type: String,
                required: true,
            },
            compact: {
                type: Boolean,
                required: false,
                default: false,
            }
        },

        watch: {
            value(value) {
                this.model = value;
            },
        },

        created() {
            this.model = this.value;
        },

        data() {
            return {
                model: null,
            }
        },

        methods: {
            emit() {
                this.$refs.validationObserver.validate()
                    .then(isValid => {
                        if (isValid) {
                            this.$emit('input', this.model);
                        }
                    });
            }
        }
    }
</script>
